export class SelectedCommentsFilter {
	selectedTab: string = "all";
	showSystemComments: boolean;
}